import React from 'react';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';

function MaskedInputFieldComponent({mask, onChange, value, children}) {
    return <InputMask
        mask={mask}
        onChange={onChange}
        value={value}
        maskPlaceholder="-"
    >
        {children}
    </InputMask>;
}

MaskedInputFieldComponent.propTypes = {
    mask: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    value: PropTypes.any
};

export default MaskedInputFieldComponent;
